module.exports = __webpack_public_path__ + "img/courier-fastfrate.bb90a21a.svg";